<template>
    <div class="flex-center actionBar">
        <div v-if="typeof icon !== 'undefined' && icon !== ''" class="icon mainIcon">
            <span @click="accordionAction" :class="icon"></span>
        </div>
        <div class="wrapper">
            <span class="title">{{title}}</span>
        </div>
        <div v-if="statusVisible && status" class="icon actionIcon">
            <span :title="status" :class="[_status.className]"></span>
        </div>
        <div v-if="!disableIcons && copyAllowed" class="icon actionIcon">
            <span @click="copyElement" class="icon-duplicate"></span>
        </div>
        <div v-if="!disableIcons" class="icon actionIcon">
            <span @click="deleteElement" class="icon-delete"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ActionBar",
        props: {
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false
            },
            status: String,
            disableIcons: {
                type: Boolean,
                default: false
            },
            copyAllowed: {
                type: Boolean,
                default: true
            },
            statusVisible: Boolean
        },
        computed: {
            _status: function () {
                let ret = {};
                /*if (this.status === "live") {
                    ret.className = 'icon-status-live';
                    ret.color = "rgb(215,4,101)";
                } else if (this.status === "ausgelaufen") {
                    ret.className = 'icon-status-finished';
                    ret.color = "rgb(36,39,45)";
                } else */
                if (this.status === "in Arbeit") {
                    ret.className = 'icon-status-inprogress grey';
                } else if (this.status === "gecheckt") {
                    ret.className = 'icon-status-inprogress blue';
                } else if (this.status.indexOf("eingebaut") !== -1) {
                    ret.className = 'icon-status-inprogress pink';
                }
                return ret;
            }
        },
        methods: {
            copyElement: function (ev) {
                this.$emit('copyElement');
                ev.stopPropagation();
            },
            deleteElement: function (ev) {
                this.$emit('deleteElement');
                ev.stopPropagation();
            },
            accordionAction: function (ev) {
                this.$emit('accordionAction');
                ev.stopPropagation();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .actionIcon {
        display: inline-block;
        padding: 1em 1em;
        position: relative;
        top: -3px;
    }

    .actionIcon span {
        font-size: 1.5em;
    }

    .actionIcon {
        cursor: pointer;
    }

    .mainIcon span {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -4px;
        width: 65px;
        font-size: 40px;
        font-weight: bold;
        color: $pink;
        margin-right: 7px;

        &.icon-device-desktop {
            font-size: 50px;
        }
    }

    .title {
        font-weight: bold;
        font-size: 1.1em;
        margin-right: 15px;
    }

    .wrapper {
        display: inline-block;
        top: -2px;
        position: relative;
    }

    .flex-center {
        display: flex;
        align-items: center;
    }

    .actionBar {
        min-height: 50px;
    }

    span {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }

    ::v-deep .icon-status-inprogress {
        &.grey {
            color: $grey;
        }

        &.blue {
            color: $blue;
        }

        &.pink {
            color: $pink;
        }
    }
</style>